module.exports = __webpack_public_path__ + "img/Olymp-logo.82a9cc30.png";